export default "__VITE_ASSET__Mflydg3T__"